export const CACHE_KEY_LIST_NOTARY_OFFICES  = 'notary-offices';
export const ROUTE_PATH_NOTARY_OFFICES = '/configuration/notary-offices';
export const TRANSLATION_PREFIX_NOTARY_OFFICES = 'notaryOffices';
export const SECURITY_KEY_NOTARY_OFFICES = 'NOTARY_OFFICES';
